export const AIAgentServiceConfig = {
    apiUrl: {
        message: 'api/v1/EVAController/message',
        historyList: '/api/v1/EVAController/GetChatHistories',
        getChatHistory: '/api/v1/EVAController/GetChatHistory',
        getSitesForCorporates: 'CustomerSites',
        getEvaResponse: 'api/v1/Conversational/GetConversationalResponseV2',
        getEvaResponseV2: 'api/v2/Conversational/GetConversationalResponse',
        getFeedback: 'api/v1/Feedback/GetFeedback',
        saveFeedback: 'api/v1/Feedback/SaveFeedback',
        getEvaChatResponse: 'api/v1/EvaDci/Chat',
        getEvaChatSessions: 'api/v1/EvaDci/Sessions',
        getEvaChatResponse2: 'DataCenterAggrService/api/v1/EvaCoolant/Chat',
        getEvaChatSessions2: 'DataCenterAggrService/api/v1/EvaCoolant/Sessions'
    }
}
